module.exports = __webpack_public_path__ + "static/media/textimonial-shape.eac054f0.svg";